/**
 * 开放平台策略
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>开放平台策略</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <el-row>
      <el-col :span="10" style="margin-top: 10px;">
        <h3 id="h3_title"> 调用限制(单个aegisAI)</h3>
        <el-form ref="form" :model="form" label-width="140px" :rules="rules">
          <!-- <el-form-item label="name" prop="name">
            <el-select size="small" v-model="form.parentId" placeholder="请选择" class="selectw">
              <el-option v-for="parm in fmenu" :key="parm.id" :label="parm.name" :value="parm.id"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="每分钟调用次数" prop="URL">
            <el-input size="small" v-model="form.policy.limit_per_minute" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="每日调用次数" prop="KEY">
            <el-input size="small" v-model="form.policy.limit_per_day" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="每月调用次数" prop="temperature">
            <el-input size="small" v-model="form.policy.limit_per_month" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="文本类输入最大限制" prop="max_tokens">
            <el-input size="small" v-model="form.policy.max_input_chars" placeholder="字符"></el-input>
          </el-form-item>
          <el-form-item label="附件大小限制" prop="top_p">
            <el-input size="small" v-model="form.policy.max_attachment_mb" placeholder="请输入">
              <template slot="append">M</template>
            </el-input>
          </el-form-item>

          <h3 id="h3_title">IP黑名单</h3>
          <el-form-item label="" prop="blacklist_ips">
            <el-input size="small" v-model="blacklist_ips" placeholder="输入IP，以分号;隔断"></el-input>
          </el-form-item>
          
          <el-form-item>
            <el-button size="small" type="primary" @click="saveModule('form')">保存</el-button>
            <el-button size="small" type="primary" v-show="showdelete" @click="deleteModule">删除</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  policyInit,
  policyInitput,
} from '../../api/userMG'
export default {
  data() {
    return {
      showdelete: false,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      blacklist_ips:'',
      form: {
        blacklist_ips:[],
        policy:[]
      },
      // rules表单验证
      rules: {
        // URL: [
        //   { required: true, message: '请输入URL', trigger: 'blur' }
        // ],
        // moduleName: [
        //   { required: true, message: '请输入菜单名称', trigger: 'blur' }
        // ],
        // moduleIcon: [
        //   { required: true, message: '请输入菜单图标', trigger: 'blur' }
        // ],
        // moduleUrl: [{ required: true, message: '请输入URL', trigger: 'blur' }],
        // moduleOrder: [
        //   { required: true, message: '请输入菜单顺序', trigger: 'blur' }
        // ]
      },
      fmenu: [
          {
            name: 'deepseek V1',
            id:'1'
          },
          {
            name: 'deepseek V2',
             id:'2'
          },
      ]
    }
  },
  /**
   * 创建完毕
   */

  created() {
    this.getdata()
    // this.getmenu()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
       // 复选变单选
    handleClick(data, checked, node) {
      if (checked) {
        this.$refs.tree.setCheckedNodes([])
        this.$refs.tree.setCheckedNodes([data])
        this.showdelete = true
      } else {
      }
    },
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
       policyInit(parameter)
        .then(res => {
          this.loading = false
          console.log(res,'配置获取数据成功')
          if (res.message == "success") {
            this.form = res.data;
            this.blacklist_ips = this.form.blacklist_ips.join(';')
            console.log(this.form,'配置获取数据成功')
          } else {
            this.$message({
              type: 'info',
              message: res.detail
            })
          }
        })
        .catch(err => {
          this.loading = false
          // this.$message.error('菜单加载失败，请稍后再试！')
        })
    },
    // 点击节点
    nodeclick(arr, node, self) {
      ModuleGet(arr.id)
        .then(res => {
          console.log(JSON.stringify(res))
          this.form = res.data.data
          this.$refs.tree.setCheckedNodes([])
          this.$refs.tree.setCheckedNodes([arr])
        })
        .catch(err => {
          this.loading = false
          this.$message.error('用户管理获取失败，请稍后再试！')
        })
    },
    // 保存菜单
    saveModule(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          if(this.blacklist_ips){
            this.form.blacklist_ips = this.blacklist_ips.split(';')
          }else{
            this.form.blacklist_ips = []
          }
          // console.log(this.form,'策略保存成功')
          // return false;
          policyInitput(JSON.stringify(this.form))
            .then(res => {
              console.log(res,'策略保存成功')
              if (res.message == "success") {
                this.$message({
                  type: 'success',
                  message: '保存成功'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.detail
                })
              }
            })
            .catch(err => {
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },

    // 删除菜单
    deleteModule() {
      ModuleDelete(this.form.moduleId)
        .then(res => {
          this.getdata()
          this.getmenu()
          this.$message.error('菜单管理列表删除成功！')
        })
        .catch(err => {
          this.$message.error('菜单管理列表删除失败，请稍后再试！')
        })
    }
  }
}
</script>

<style>
.user-search {
  margin-top: 20px !important;
}
.user-search td {
  margin-top: 20px !important;
}
.userRole {
  width: 100%;
}
.el-table__expanded-cell {
  padding: 0px !important;
  margin: 0px !important;
}

.mod-btnbox {
  margin-bottom: 20px;
}
.treeclass {
  border: 1px solid #f3f3f3;
  padding-top: 20px;
  padding-bottom: 20px;
}
.selectw {
  width: 100%;
}
#h3_title{
  margin-left: 40px;
}
</style>
 
 


// WEBPACK FOOTER //
// src/views/strategy/index.vue